import { z } from "zod";

if (navigator?.product === "ReactNative") {
  z.setErrorMap((issue, ctx) => {
    const type: string = (issue as any)?.type;
    if (issue.code === "invalid_type" && type === undefined) {
      return {
        message: "validation.required",
      };
    }
    if (zodLocale?.[type]?.[issue.code])
      return {
        message: zodLocale[type][issue.code],
      };
    if ((issue as any).validation === "email")
      return {
        message: zodLocale["string"]["email"],
      };
    return { message: ctx.defaultError };
  });
}

export const zodLocale: {
  [key: string]: { [key: string]: string };
} = {
  string: {
    email: "validation.email",
    too_small: "validation.minCharacters",
    too_big: "validation.maxCharacters",
  },
  date: {
    too_small: "validation.dateTooSmall",
    too_big: "validation.dateTooBig",
  },
};
export * from "./en";
export * from "./es";
export * from "./fr";
export * from "./nl";
export * from "./pt";
